export default {
  title: {
    en: 'Activate your account',
  },
  text: {
    en: 'Subscribers have exclusive access to all limited edition products.',
  },
  confirmButton: {
    en: 'Subscribe',
  },
  cancelButton: {
    en: 'No, I don\'t want to save money and try<br />awesome beauty products',
  },
}
